import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { CommonSetting } from "../../components/setting/CommonSetting";
import { StyleSheet, View } from "react-native";
import React, { useEffect, useState } from "react";
import { MainNavProps } from "../navigation/main/MainParamList";
import {
  Str_AccountSecurity,
  Str_ActivateSecurity,
  Str_ApplyDelAcc,
  Str_ChangeLoginPsd,
  Str_Email,
  Str_Man,
  Str_NotSet,
  Str_SwitchAccount,
  Str_Woman,
} from "../../language/string_res";
import { getUid, getVcode } from "../../store/token";
import { useStore } from "../../store/UserStore";
import * as ImSdk from "../../../imsdk/api";
import { UserSchema } from "../../realm/contactSchema";
import { User } from "../../../imsdk/db/t_user";
import { useTranslation } from "react-i18next";
import { useIsFocused } from "@react-navigation/core";

export const AccountSecuritySetting = ({
  navigation,
}: MainNavProps<"AccountSecuritySetting">) => {
  const uid = getUid();
  const { state, dispatch } = useStore();
  const [user, setUser] = useState<UserSchema | User>();
  const [email, setEmail] = useState("");
  const [telno, setTelno] = useState("");

  useTranslation();
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      fetchDetail();
    }
  }, [isFocused]);

  function fetchDetail() {
    ImSdk.getInstance()
      .GetUserRemote(uid)
      .then((res) => {
        if (res && res.users && res.users.length > 0) {
          const user = res.users[0];
          setUser(user);
          setTelno(getTel(user));
          setEmail(getEmail(user));
          user.sex =
            user.sex === Str_Woman ? "0" : user.sex === Str_Man ? "1" : "2";
          dispatch({
            type: "UPDATE_USER_INFO",
            payload: user,
          });
        }
      });
  }

  useEffect(() => {
    setUser(state?.user);
    setTelno(getTel(state?.user));
    setEmail(getEmail(state?.user));
  }, [state?.user]);

  function getTel(data?: UserSchema) {
    const tel = data?.rtel;
    return tel && tel.trim() !== "" ? tel : Str_NotSet;
  }

  function getEmail(data?: UserSchema) {
    const email = data?.remail;
    return email && email.trim() !== "" ? email : Str_NotSet;
  }

  const done = () => {
    fetchDetail();
  };

  return (
    <BaseScreen>
      <NavBar showBack={false} title={Str_AccountSecurity} />

      <View style={styles.contentContainer}>
        <CommonSetting
          style={{ marginTop: 12, borderRadius: 0 }}
          itemOption={[
            // {
            //     text: Str_Telno,
            //     rightType: "Back",
            //     onClick: () => {
            //         navigation.navigate('BindPhoneOrEmail', { type: 'phone', defValue: user?.rtel })
            //     },
            //     rightText: telno,
            // },
            // {
            //   text: Str_Email,
            //   rightType: "Back",
            //   onClick: () => {
            //     navigation.navigate("BindPhoneOrEmail", {
            //       type: "email",
            //       defValue: user?.remail,
            //     });
            //   },
            //   rightText: email && email.trim() !== "" ? email : undefined,
            // },
            {
              text: Str_ChangeLoginPsd,
              rightType: "Back",
              onClick: () => {
                navigation.navigate("UpdatePsdSetting");
              },
            },
            // {
            //   text: Str_ActivateSecurity,
            //   rightType: "Back",
            //   onClick: () => {
            //     const account = state?.user?.employee;
            //     if (account) {
            //       navigation.navigate("OpenSecurity", {
            //         from: "setting",
            //         account: account,
            //         vcode: getVcode(),
            //       });
            //     }
            //   },
            // },
            {
              text: Str_ApplyDelAcc,
              rightType: "Back",
              onClick: () => {
                navigation.navigate("AskAccountDel");
              },
            },
            {
              text: Str_SwitchAccount,
              rightType: "Back",
              onClick: () => {
                navigation.navigate("SwitchAccount");
              },
            },
          ]}
        />
      </View>
    </BaseScreen>
  );
};
const styles = StyleSheet.create({
  contentContainer: {
    width: "100%",
    maxWidth: 800,
    alignSelf: "center",
    paddingHorizontal: 20,
    marginTop: 40,
    backgroundColor: "white",
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    paddingTop: 8,
    paddingBottom: 8,
  },
  title: {
    fontSize: 17,
    color: "black",
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "lucida grande",
    textAlignVertical: "center",
  },
});
